module.exports = __webpack_public_path__ + "img/cartoonHead1-1.ac4783e8.png";